(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.administration');
    module.controller('LicencesOverviewController', ['$scope', '$state', 'licences', 'SharedAgendaService', 'PaginationService', LicencesOverviewControllerFn]);

    /* controller for licences overview */
    function LicencesOverviewControllerFn($scope, $state, licences, SharedAgendaService, PaginationService) {
        /* jshint validthis:true */
        var vm = this;

        vm.overview = null;

        $scope.$on('$viewContentLoaded', function () {
            App.initAjax(); // initialize core components
        });

        /* create new licence */
        vm.new = function () {
            $state.go('Home.Administration.LicenceDetail');
        };

        activate();

        /* load work */
        function activate() {
            // allow shared agendas
            SharedAgendaService.allow();
            vm.overview = new PaginationService(licences);

        } // activate
    }
})();
